export const br = {
  categories: [
    {
      id: 1,
      label: 'Cursos de Fotografía',
      href: '/br/cursos-online-fotografia-y-video/',
    },
    {
      id: 2,
      label: 'Cursos de Marketing Digital',
      href: '/br/cursos-online-marketing/',
    },
    {
      id: 3,
      label: 'Cursos de Animação',
      href: '/br/cursos-online-modelado-y-animacion-3d/',
    },
    {
      id: 4,
      label: 'Cursos de Liderança',
      href: '/br/cursos-online-liderazgo/',
    },
    {
      id: 5,
      label: 'Cursos de Desenvolvimento Web',
      href: '/br/cursos-online-diseno-y-desarrollo-de-productos-digitales/',
    },
  ],
  subcategories: [
    {
      id: 6,
      label: 'Cursos de Maquiagem',
      href: '/br/cursos-online-estilo-de-vida/',
    },
    {
      id: 7,
      label: 'Cursos de Redes Sociais',
      href: '/br/cursos-online-redes-sociales/',
    },
    {
      id: 8,
      label: 'Cursos de Design de interiores',
      href: '/br/cursos-online-diseno-de-interiores/',
    },
    {
      id: 9,
      label: 'Cursos de Empreendimento',
      href: '/br/cursos-online-administracion-y-finanzas/',
    },
    {
      id: 10,
      label: 'Cursos de Branding',
      href: '/br/cursos-online-lettering/',
    },
  ],
  softwares: [
    {
      id: 11,
      label: 'Cursos de Microsoft Excel',
      href: '/br/cursos-online-microsoft-excel/',
    },
    {
      id: 12,
      label: 'Cursos de Adobe Photoshop',
      href: '/br/cursos-online-adobe-photoshop/',
    },
    {
      id: 13,
      label: 'Cursos de After Effects',
      href: '/br/cursos-online-adobe-after-effects/',
    },
    {
      id: 14,
      label: 'Cursos de Google Ads',
      href: '/br/cursos-online-google-ads/',
    },
    {
      id: 15,
      label: 'Cursos de Procreate',
      href: '/br/cursos-online-procreate/',
    },
  ],
  specializations: [
    {
      id: 17,
      label: 'UX/UI para design de produtos',
      href: '/microdegree/ux-ui/',
    },
    {
      id: 18,
      label: 'Marketing Digital',
      href: '/microdegree/marketing-digital/',
    },
    {
      id: 19,
      label: 'Degree de Data Analytics',
      href: '/microdegree/data-analytics/',
    },
    {
      id: 20,
      label: 'Product Management',
      href: '/microdegree/product-management/',
    },
  ],
};
